import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import {
    api
} from '../../helpers/api_helper';
import Log from '../../Services/Log';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';





export const getAllAnalytics = createAsyncThunk(`${API_ENDPOINTS.BASE_URL}/work/all?limit=100&page=1&status=verified`, async (info, thunkAPI) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.BASE_URL}/work/all?limit=100&page=1`);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
export const getAdById = createAsyncThunk('ads/getAdById', async (id, thunkAPI) => {
    try {
        const response = await api.get(`${API_ENDPOINTS.ADS.GET_INDIVIDUAL_AD}?ad_id=${id}`);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
// export const getSingleAdAnalytics = createAsyncThunk(
//     '/dev/v1/analytics/get',
//     async ({ type, adId }, thunkAPI) => {
//         try {
//             const response = await api.get(`/dev/v1/analytics/get?type=${type}&ad_id=${adId}`);
//             return response.data;
//         } catch (error) {
//             return thunkAPI.rejectWithValue(error.response.data);
//         }
//     }
// );

export const getSingleAdAnalytics = createAsyncThunk(
    'analytics/getSingle',
    async ({
        type,
        adId,
        limit,
        page
    }, thunkAPI) => {
        try {
            const response = await api.get(`${API_ENDPOINTS.BASE_URL}/analytics/get?type=${type}&ad_id=${adId}&limit=${limit}&page=${page}`);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);